import {RefObject, useEffect, useState} from 'react';
import {useScroll} from './useScroll';

interface IProps {
    ref: RefObject<HTMLElement>;
    topOffset?: number;
}

export const useIsFixed = ({ref, topOffset = 0}: IProps) => {
    const [top, setTop] = useState(0);

    useEffect(() => {
        setTop(ref.current?.getBoundingClientRect().top || 0);
    }, [ref]);

    return useScroll(top + topOffset, 0);
};
